import React, { useState } from "react";
import ImageLoading from "../../components/ImageLoading";
import NoDataFound from "../../components/NoDataFound";
import StockAnalyzer from "./StockAnalyzer";
import MutualFundAnalyzer from "./MutualFundAnalyzer";
import RealEstateAnalyzer from "./RealEstateAnalyzer";
import VehicleAnalyzer from "./VehicleAnalyzer";
import BSA from "../IndividualAssets/BSA/BSA";

function AnalyzerItems({ flag, id }) {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [noData, setNoData] = useState(false);

  return (
    <>
      {loading && (
        <div className="w-full h-[calc(100vh-190px)] flex items-center justify-center bg-white mt-4 rounded-lg">
          <ImageLoading />
        </div>
      )}
      {noData && (
        <div className="w-full h-[calc(100vh-190px)] flex items-center justify-center bg-white mt-4 rounded-lg">
          <NoDataFound />
        </div>
      )}
      {!loading &&
        !noData &&
        (flag === "Stock" ? (
          <StockAnalyzer id={id} />
        ) : flag === "Mutual Fund" ? (
          <MutualFundAnalyzer id={id} />
        ) : flag === "Bank Account Statement" ? (
          <BSA id={id} />
        ) : flag === "Real Estate" ? (
          <RealEstateAnalyzer id={id} />
        ) : flag === "Vehicle" ? (
          <VehicleAnalyzer id={id} />
        ) : (
          <div></div>
        ))}
    </>
  );
}

export default AnalyzerItems;
